import { ITabsData } from './types';

export const GetScrollLeftValueForTabContainer = (tabsData: ITabsData) => {
  if (!tabsData.tabContainerRef) return;
  const tabContainer = tabsData.tabContainerRef;
  const currentActiveTab = tabsData.currentActiveTab;
  const firstTabTitle = tabsData.tabsTitles[0];
  const activeElement = tabContainer.querySelector('.active');
  const getProperOffsetLeft = () => (activeElement ? activeElement.offsetLeft : tabContainer.lastChild.offsetLeft);
  const isFirstTabActive = currentActiveTab == firstTabTitle;
  return isFirstTabActive ? 0 : getProperOffsetLeft();
};
